export enum CardEventMsg {
  ERROR_GET_DATA = 'ERROR_GET_DATA',
  ERROR_PUT_DATA = 'ERROR_PUT_DATA',
  ERROR_POST_DATA = 'ERROR_POST_DATA',
  SUCCESS_CREATE = 'SUCCESS_CREATE',
  SUCCESS_UPDATE = 'SUCCESS_UPDATE',
  SUCCESS_GET = 'SUCCESS_GET',
  NO_DATA = 'NO_DATA'
}
